import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { AppContentComponent } from './container/content/content.component';
import { AppFooterComponent } from './components/footer/footer.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { AboutComponent } from './components/about/about.component';
import { LanguageService } from './services/language.service';
import { ImprintComponent } from './components/imprint/imprint.component';
import { PhilosophyComponent } from './components/philosophy/philosophy.component';
import { ServicesOverviewComponent } from './components/services-overview/services-overview.component';
import { CompetenceComponent } from './components/competence/competence.component';
import { ContactComponent } from './components/contact/contact.component';
import { ServicesBDComponent } from './components/services-bd/services-bd.component';
import { ServicesCTComponent } from './components/services-ct/services-ct.component';
import { ServicesSemiconductorsComponent } from './components/services-semiconductors/services-semiconductors.component';
import { AGBComponent } from './components/agb/agb.component';
import { DataSecurityComponent } from './components/data-security/data-security.component';
import { ServicesReComponent } from './components/services-re/services-re.component';


const appRoutes: Routes = [
  { path: 'about', component: AboutComponent },
  { path: 'philosophy', component: PhilosophyComponent },
  { path: 'services-overview', component: ServicesOverviewComponent },
  { path: 'business-development', component: ServicesBDComponent },
  { path: 'clean-technology', component: ServicesCTComponent },
  { path: 'semiconductors', component: ServicesSemiconductorsComponent },
  { path: 'reliability-engineering', component: ServicesReComponent },
  { path: 'competence', component: CompetenceComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'imprint', component: ImprintComponent },
  { path: 'terms-conditions', component: AGBComponent },
  { path: 'data-security', component: DataSecurityComponent },
  { path: '',
    redirectTo: '/about',
    pathMatch: 'full'
  },
  { path: '**',
    redirectTo: '/about',
    pathMatch: 'full'
  },
];

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    AppContentComponent,
    AppFooterComponent,
    AboutComponent,
    ImprintComponent,
    PhilosophyComponent,
    CompetenceComponent,
    ServicesOverviewComponent,
    ServicesBDComponent,
    ServicesCTComponent,
    ServicesSemiconductorsComponent,
    ContactComponent,
    AGBComponent,
    DataSecurityComponent,
    ServicesReComponent,
  ],
  imports: [
    BrowserModule,
    NgbModule.forRoot(),
    RouterModule.forRoot(
      appRoutes, {useHash: true},
    ),
  ],
  providers: [
    LanguageService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts